// extracted by mini-css-extract-plugin
export default {"container":"CohortSubText__container___Hprqw","moreItemContainer":"CohortSubText__moreItemContainer___RkZRi","skeleton-loading":"CohortSubText__skeleton-loading___atDIi"};